module.exports = __webpack_public_path__ + "media/images/G-06-24509dc077d753869b69be72a0d6404d.svg";